import React from 'react';
import FiftyFifty from './FiftyFifty';

import Img1 from '../../statics/img/1.jpg';
import Img2 from '../../statics/img/2.jpg';
import Img3 from '../../statics/img/3.jpg';

import { CalciteBtn } from '../Calcite';

const FiftyFiftyContainer = () => {
    return (
        <div>
            <FiftyFifty
                imageURL={Img1}
                title={'Modeling Land Cover Change and Vulnerability'}
                content={
                    <>
                        <p className="mb-4">
                            To discover which areas of the planet are most vulnerable to change, each country’s land cover was evaluated from 2010 to 2018. This evaluation was used to develop a vulnerability model that identifies where development could convert natural vegetation to agriculture and urban lands by the year 2050. The land cover vulnerability model uses several quantitative and qualitative variables to understand the global pressures of land development, including distance to modified areas, infrastructure, population counts, Gross Domestic Product (GDP) data, as well as geophysical and bioclimate data. The forecast for each country is merged to produce future land cover and vulnerability maps of the world with a 300-meter resolution.
                        </p>
                    </>
                }
            />

            <FiftyFifty
                imageURL={Img2}
                title={'Resources for Land Use Planning'}
                reversed={true}
                content={
                    <>
                        <p className="mb-4">
                            These layers can be accessed dynamically from <a href="https://livingatlas.arcgis.com/en/home/" target="_blank" rel="noreferrer">ArcGIS Living Atlas</a> or downloaded as a series of global GeoTIFFs for offline use by the GIS community.
                        </p>

                        <ul className="mb-4">
                            <li className='list-disc list-inside'><a href="https://arcgis.com/home/item.html?id=3cce97cba8394287bcaf60f7618a5500" target="_blank" rel="noreferrer">Country-level land cover classification for 2050 </a> (<a href="https://arcgis.com/home/item.html?id=b5ee7191eda1425fa18c26532683896d" target="_blank" rel="noreferrer">Download</a>).</li>
                            <li className='list-disc list-inside'><a href="https://arcgis.com/home/item.html?id=07f8b3cf1a13461d98b17bcea24abeb8" target="_blank" rel="noreferrer">Country-level vulnerability to change by 2050</a> (<a href="https://arcgis.com/home/item.html?id=c5bef54088394ba79115cbff73436cb3" target="_blank" rel="noreferrer">Download</a>).</li>
                            <li className='list-disc list-inside'><a href="https://arcgis.com/home/item.html?id=91288ee7299b4f328147f9ad8bac617f" target="_blank" rel="noreferrer">Land conservation from natural to developing areas between 2018 to 2050 </a> (<a href="https://arcgis.com/home/item.html?id=645c280931ac486cadb92c828eac09e3" target="_blank" rel="noreferrer">Download</a>).</li>
                        </ul>                                          
                    </>
                }
            />

            <FiftyFifty
                imageURL={Img3}
                title={'Esri\'s Commitment to Open Science Sustainability'}
                content={
                    <>
                        <p className="mb-4">
                            Understanding a sustainable future requires open access to authoritative data from authoritative sources. Esri will be providing the entire 2050 Land Cover map series as a free and openly accessible resource. These maps are a part of a growing collection of map layers in Esri’s ArcGIS Living Atlas of the World accessed under a Creative Commons license (CC-BY-4.0). Users are invited to explore the 2050 Land Cover maps series and combine it with other authoritative resources, such as the recently released <a href='https://livingatlas.arcgis.com/landcover/' target='_blank' rel='noreferrer'>Esri 2020 Land Cover map</a>.
                        </p>

                        <p className="mb-4">
                            Learn more about <a href="" target="_blank" rel="noreferrer">Esri's Open Science Sustainability</a>.
                        </p>

                        <div className="text-right mt-2">
                            <CalciteBtn
                                lable={'Access the Collection'}
                                iconStart={'collection'}
                                onClick={() => {
                                    window.open(
                                        `https://arcgis.com/home/group.html?id=65b9e9870f5a439fb467911a1d2e54d0`,
                                        '_blank'
                                    );
                                }}
                            />
                        </div>
                    </>
                }
            />

        </div>
    );
};

export default FiftyFiftyContainer;
